import { useEffect, useRef, useState } from "react";
import { Spin, Typography } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useClient } from "../../context/ClientContext";
import { api } from "../../services/api";

const { Text } = Typography;

// PagoPayPal es la página a la que PayPal devuelve al cliente después de
// aprobar el pago. Le pide al backend que capture la orden (recién ahí se cobra)
// y lo manda a la pantalla que corresponda. Si algo falla en el camino, el
// webhook acredita igual: por eso el error dice que puede llegar solo.
export const PagoPayPal = () => {
  const navigate = useNavigate();
  const { clientPath } = useClient();
  const [params] = useSearchParams();
  const pedidoId = params.get("pedido");
  const ordenId = params.get("token"); // PayPal manda el id de la orden como token
  const [error, setError] = useState("");
  const pedido = useRef(false);

  useEffect(() => {
    // En desarrollo React monta dos veces: una sola captura alcanza.
    if (pedido.current) return;
    pedido.current = true;
    const ref = `?external_reference=${pedidoId}`;
    if (!pedidoId || !ordenId) {
      navigate(clientPath(`/pedido/fallido${pedidoId ? ref : ""}`), { replace: true });
      return;
    }
    api.pagos.capturarPaypal(pedidoId, ordenId)
      .then((res) => {
        if (res.status !== "success") { setError(res.message || "No se pudo confirmar el pago."); return; }
        const destino = { paid: "/pedido/exitoso", failed: "/pedido/fallido" }[res.data?.estado] || "/pedido/pendiente";
        navigate(clientPath(destino + ref), { replace: true });
      })
      .catch(() => setError("No se pudo confirmar el pago. Si PayPal te lo cobró, se va a acreditar solo en unos minutos."));
  }, [pedidoId, ordenId, navigate, clientPath]);

  return (
    <div style={{ minHeight: "70vh", display: "flex", alignItems: "center", justifyContent: "center", padding: "40px 20px" }}>
      <div style={{ textAlign: "center", maxWidth: 440 }}>
        {error ? (
          <>
            <h2 style={{ fontWeight: 700, marginBottom: 8 }}>No pudimos confirmar el pago</h2>
            <Text type="secondary" style={{ display: "block", marginBottom: 20 }}>{error}</Text>
            <a href={clientPath(`/mis-pedidos/${pedidoId}`)}>Ver el pedido</a>
          </>
        ) : (
          <>
            <Spin size="large" />
            <Text type="secondary" style={{ display: "block", marginTop: 16 }}>Confirmando el pago con PayPal…</Text>
          </>
        )}
      </div>
    </div>
  );
};
